import api from 'utils/api';
import { getAPIBase } from 'utils/api/apiBase';

export const getCustomerPortalUrl = async () => {
  return api.get(`${getAPIBase()}/get_customer_portal_url/`).then((response) => response?.data?.url);
};
